import {Trans} from '@lingui/macro';
import {
  AppBar,
  Badge,
  CssBaseline,
  Divider,
  Drawer,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import {
  MenuRounded,
  NotificationsNone,
  PersonOutline,
} from '@material-ui/icons';
import SettingsIcon from '@material-ui/icons/Settings';
import {Roles} from 'app/Constants';
import {i18n2} from 'features/i18n/i18n';
import {logout} from 'features/login/actions';
import PopupState, {bindPopover, bindTrigger} from 'material-ui-popup-state';
import React from 'react';
import {useSelector} from 'react-redux';
import {Link, Redirect} from 'react-router-dom';
import BaliardaLogo from '../../content/images/logos baliarda/logo-white.png';
import {useTabletCourse} from '../capacitation/hookos/hooks';
import LangSelector from '../i18n/components/LangSelector';
import navigationRoutes from './navigationRoutes';
import Notification from './notification/Notification';
import useStyles from './useStyles';
import displayLinks from './sideMenuUtils';
import {useHistory} from 'react-router-dom';
import {ensureSessionOrRedirect} from 'helpers/session';

//Ver de mejorar estecomponente hacerlo responsive
const Nav = (props) => {
  let user = JSON.parse(sessionStorage.getItem('user'));
  const rol = useSelector((state) => state.authentication.user.roles[0].role);
  const classes = useStyles();
  const {tablet, assistants} = useTabletCourse();
  const array = useSelector((state) => state.NotificationReducer.notification);

  // Drawer
  const [drawerState, setDrawer] = React.useState(false);
  const toggleDrawer = (newState) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setDrawer(newState);
  };

  // Anchor
  const [anchorEl, setAnchorEl] = React.useState(null);

  const userClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const userClose = () => {
    setAnchorEl(null);
  };
  const openAnchor = Boolean(anchorEl);
  const idPopup = openAnchor ? 'simple-popover' : undefined;
  const history = useHistory();

  const sideList = () => {
    return (
      <div
        role="presentation"
        onClick={toggleDrawer(true)}
        onKeyDown={toggleDrawer(false)}>
        {displayLinks(navigationRoutes, rol)}
      </div>
    );
  };

  const openOrCloseDrawer = () => {
    setDrawer(!drawerState);
  };

  if (
    assistants &&
    !(
      props.children.props.location.pathname.toLowerCase() ===
        '/tabletcourse' ||
      props.children.props.location.pathname.toLowerCase() ===
        '/capacitation' ||
      props.children.props.location.pathname.toLowerCase() ===
        '/confirmcredentials'
    )
  ) {
    return <Redirect to="/confirmCredentials" push />;
  }

  if (!user) {
    return null;
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appbar}>
        <Toolbar className={classes.toolbar} style={{padding: 0}}>
          <IconButton onClick={() => openOrCloseDrawer()} disabled={tablet}>
            <MenuRounded className={classes.icon} />
          </IconButton>
          <div className={classes.image}>
            <span className={classes.helper}></span>
            <img
              src={BaliardaLogo}
              alt="Mox It Logo"
              className={classes.logo}
              onClick={() => {
                if (assistants) return;

                if (!ensureSessionOrRedirect()) {
                  history.replace('/login');
                  return;
                }

                history.push('/Dashboard');
              }}
            />
            <span className={classes.brand}>e-Learning</span>
          </div>
          <div className={classes.buttons}>
            <LangSelector />

            <PopupState variant="popover" popupId="demo-popup-popover">
              {(popupState) => (
                <>
                  <IconButton
                    disabled={assistants}
                    {...bindTrigger(popupState)}>
                    <Badge
                      badgeContent={array.length}
                      classes={{badge: classes.customBadge}}>
                      <NotificationsNone className={classes.icon} />
                    </Badge>
                  </IconButton>
                  <Popover
                    {...bindPopover(popupState)}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}>
                    <Box p={0}>
                      <Notification />
                    </Box>
                  </Popover>
                </>
              )}
            </PopupState>
            {rol !== Roles.Collaborator && (
              <IconButton
                component={Link}
                to={'/Settings'}
                disabled={assistants}>
                <SettingsIcon className={classes.icon} />
              </IconButton>
            )}
            <IconButton
              onClick={userClick}
              aria-describedby={idPopup}
              disabled={assistants}>
              <PersonOutline className={classes.icon} />
            </IconButton>
            <div style={{paddingLeft: 10, paddingRight: 10}}>
              <Menu
                id={idPopup}
                open={openAnchor && !assistants}
                anchorEl={anchorEl}
                onClose={userClose}
                transformOrigin={{
                  vertical: -40,
                  horizontal: 'left',
                  paddingLeft: 10,
                  paddingRight: 10,
                }}>
                <ListItemText
                  style={{
                    textAlign: 'center',
                    paddingLeft: 10,
                    paddingRight: 10,
                  }}
                  primary={user.cwid}
                  secondary={
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="body2"
                        color="textSecondary">
                        {user.sector_Name}
                        <Divider variant="fullWidth" />
                        {rol === 'Trainer' ? i18n2._('Trainer') : rol}
                      </Typography>
                    </React.Fragment>
                  }
                />
                <Divider />
                <MenuItem
                  style={{justifyContent: 'center'}}
                  component={Link}
                  to="/change-password"
                  onClick={userClose}>
                  Cambiar contraseña
                </MenuItem>
                <MenuItem
                  style={{justifyContent: 'center'}}
                  onClick={() => {
                    userClose();
                    logout();
                  }}>
                  <Trans>Cerrar sesión</Trans>
                </MenuItem>
              </Menu>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        open={drawerState && !assistants}
        onClose={toggleDrawer(false)}
        className={classes.drawer}
        classes={{
          paper: classes.drawerPaper,
        }}>
        <div className={classes.toolbar} />
        {sideList()}
      </Drawer>
      <div className={classes.content}>
        <div className={classes.toolbar} />
        {props.children}
      </div>
    </div>
  );
};

export default Nav;
